import { Component, Inject, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { viewerType } from '@src/constants';
import { packagesActions } from '@src/store/reducers/packagesReducer';
import { scriptsActions } from '@src/store/reducers/scriptsReducer';
import { ScriptViewerDialogData } from './script-viewer-dialog.data';

import CodeMirror from 'codemirror/lib/codemirror';
import 'codemirror/theme/base16-light.css';
import 'codemirror/mode/sql/sql';

@Component({
    selector : 'script-viewer-dialog',
    template: require('./script-viewer-dialog.component.html'),
    styles: [require('./script-viewer-dialog.component.scss')]
})
export class ScriptViewerDialogComponent implements AfterViewInit {
    @ViewChild('textarea') public textarea: ElementRef;

    public isScriptViewer: boolean;
    public packageEditMode = false;
    public packageEditModeEnable: boolean;
    public isShowScript = true;
    public isEnabled = true;
    public scriptContent: string;
    public viewLink: string;
    public downloadLink: string;
    public canEditPackageScripts: boolean;

    private codeMirror: any;

    constructor(
        private dialogRef: MatDialogRef<ScriptViewerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ScriptViewerDialogData) {
        this.isScriptViewer = data.viewerType !== viewerType.Audit;
        this.isEnabled = data.isEnabled || true;
        this.canEditPackageScripts = data.canEditPackageScripts;
        this.packageEditModeEnable = this.data.isPackageMode || false;
        this.scriptContent = data.script || '';
    }

    public async ngAfterViewInit() {
        this.codeMirror = CodeMirror.fromTextArea(this.textarea.nativeElement, {
            lineWarp: true,
            indentWithTabs: true,
            readonly: true,
            smartIndent: true,
            matchBrackets: true,
            theme: 'base16-light',
            mode: 'text/x-sql'
        });
        this.codeMirror.setOption('readOnly', true);

            if (this.data.isDefaultEdit) {
                await this.onEditMode();
            }
            if (this.isScriptViewer) {
                if (this.data.packageId == '' && this.data.scriptId == '' && this.data.projectId == '') {
                    this.setScriptContent(this.data.script);
                    return;
                }
                try {
                    let response = null;
                    if (this.data.packageId) {
                        const payloadData = { projectId: this.data.projectId, packageId: this.data.packageId, scriptId: this.data.scriptId };
                        response = await this.data.dispatch({ type: scriptsActions.GET_SCRIPT_DATA, payload: payloadData });
                    } else {
                        const payloadData = { projectId: this.data.projectId, scriptId: this.data.scriptId };
                        response = await this.data.dispatch({ type: scriptsActions.GET_SCRIPT_DATA_WITHOUT_PACKAGE, payload: payloadData });
                    }
                    this.isShowScript = response.data.isShowScript;
                    this.viewLink = `${response.data.rawLink}?token=${this.data.userToken}`;
                    this.downloadLink = `${response.data.downloadLink}?token=${this.data.userToken}`;
                    this.setScriptContent(response.data.scriptContent);
                } catch { }
            } else {
                this.isShowScript = !this.data.isOverSize;
                this.viewLink = `${this.data.rawLink}?token=${this.data.userToken}`;
                this.downloadLink = `${this.data.downloadLink}?token=${this.data.userToken}`;
                this.setScriptContent(this.data.script);
            }

    }

    public async onEditMode() {
        if (this.packageEditModeEnable && !this.packageEditMode) {
            this.packageEditMode = true;
            this.codeMirror.setOption('readOnly', false);
        } else if (this.packageEditModeEnable && this.packageEditMode) {
            const payloadData = {
                projectId: this.data.projectId,
                scriptId: this.data.scriptId,
                packageId: this.data.packageId || 0,
                content: this.codeMirror.getValue()
            };
            await this.data.dispatch({ type: packagesActions.UPDATE_PACKAGE_SCRIPT, payload: payloadData });
            this.dialogRef.close(true);
        }
    }

    public openLink(link: string) {
        window.open(link, '_blank');
    }

    private setScriptContent(content: string) {
        this.scriptContent = content || '';
        this.codeMirror.getDoc().setValue(content);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/script-viewer-dialog/script-viewer-dialog.component.ts